module.exports = __webpack_public_path__ + "static/media/logo_large.d335705a.svg";